<template>
  <div class="withdraw-wrapper py-3">
    <div class="withdraw-card-v2 mb-4">
      <div class="withdraw-content-v2" v-html="$t('withDrawCustomerModalBody', {
        policyName: `<a href='https://vnptai.io/vi/baovedulieucanhan' target='_blank' style='color: inherit; text-decoration: underline;'>${$t('personalDataProtectionPolicy')}</a>`,
      })">
      </div>  
    </div>

    <div class="withdraw-actions-v3 d-flex justify-content-center" style="gap: 16px;">
      <b-button @click="$bvModal.hide(modalId)" class="btn-cancel-v3 flex-fill">
        {{ $t('cancel') }}
      </b-button>

      <b-button @click="onConfirmWithdraw" class="btn-confirm-v3 flex-fill">
        {{ $t('agree') }}
      </b-button>
    </div>
  </div>
</template>

<style lang="scss">
.withdraw-modal-custom {
  .modal-content {
    border-radius: 24px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 25px 60px rgba(0, 0, 0, 0.2);
    font-family: 'Be Vietnam Pro', sans-serif;
    background: #ffffff;
  }

  .modal-header {
    border-bottom: none;
    padding: 32px 32px 0;
    
    .modal-title {
      font-weight: 800;
      color: #1A202C;
      width: 100%;
      text-align: center;
      font-size: 24px;
      letter-spacing: -0.03em;
    }

    .close {
      display: none;
    }
  }

  .modal-body {
    padding: 0 32px 40px;
  }
}

.withdraw-wrapper {
  text-align: center;
}

.withdraw-badge {
  .badge-text {
    background: rgba(220, 53, 69, 0.1);
    color: #DC3545;
    padding: 6px 16px;
    border-radius: 100px;
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border: 1px solid rgba(220, 53, 69, 0.2);
  }
}

.withdraw-card-v2 {
  background: linear-gradient(135deg, rgba(255, 245, 245, 0.8) 0%, rgba(255, 255, 255, 0.9) 100%);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(220, 53, 69, 0.15);
  border-radius: 20px;
  padding: 28px;
  box-shadow: inset 0 0 20px rgba(220, 53, 69, 0.02);
  
  .withdraw-content-v2 {
    color: #4A5568;
    line-height: 1.8;
    font-size: 16px;
    text-align: center;
    
    b {
      color: #C53030;
      font-weight: 800;
      position: relative;
      background-repeat: no-repeat;
      background-size: 100% 0.3em;
      background-position: 0 88%;
    }
  }
}

.withdraw-actions-v3 {
  .btn-confirm-v3 {
    background: linear-gradient(135deg, #FF5C5C 0%, #C53030 100%);
    border: none;
    height: 52px;
    font-weight: 700;
    border-radius: 14px;
    color: white;
    font-size: 16px;
    box-shadow: 0 10px 20px rgba(197, 48, 48, 0.2);

    &:hover {
      box-shadow: 0 12px 25px rgba(197, 48, 48, 0.3);
    }
  }

  .btn-cancel-v3 {
    background: #F7FAFC;
    border: 1px solid #E2E8F0;
    color: #4A5568;
    height: 52px;
    font-weight: 700;
    border-radius: 14px;
    font-size: 16px;

    &:hover {
      background: #EDF2F7;
      color: #2D3748;
      border-color: #CBD5E0;
    }
  }
}
</style>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import BaseComponent from "@/components/BaseComponent";
import * as policyService from "@/service/policyService";
import * as userService from "@/service/userService";
import * as util from "@/service/util";
import { PrivacyConsentSource } from '@/views/enums/PrivacyConsentSource';

@Component
export default class WithdrawModal extends BaseComponent {
  @Prop({ type: String, required: true }) readonly modalId!: string;

  async onConfirmWithdraw() {
    try {
      this.showLoading();
      const clientAddress = await util.getClientAddress();
      const consentSource = PrivacyConsentSource.WITHDRAW;
      await policyService.saveActivePolicyConsent({ clientAddress, consentSource });
      this.$bvModal.hide(this.modalId);
      this.toastSuccessDelay(this.$t("withDrawCustomerSuccess") as string);
      setTimeout(() => {
        userService.signOut();
      }, 500);
    } catch (e) {
      this.toastError(e);
    } finally {
      this.hideLoading();
    }
  }
}
</script>
